import {inlineError} from '@s-ui/decorators'
import {Service} from '@s-ui/domain'

/**
 * @implements Service
 */
export default class GetUserByIdUserService extends Service {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Service} deps.service
   * @param {Object} deps.log
   */
  constructor({updateCurrentUserService, userRepository}) {
    super()

    this._updateCurrentUserService = updateCurrentUserService
    this._userRepository = userRepository
  }

  @inlineError
  async execute({currentUser}) {
    const [error, userData] = await this._userRepository.getUserById({
      currentUser
    })

    if (error) return error
    this._updateCurrentUserService.execute({
      updateCurrentUserRequest: userData
    })

    return userData
  }
}
